import React, { useState } from 'react';
import Icon from '@ramsey-design-system/icon';
import { ChevronRightIcon } from '@ramsey-design-system/icons/dist/ChevronRightIcon';
import { ChevronDownIcon } from '@ramsey-design-system/icons/dist/ChevronDownIcon';

// Styles
import '@ramsey-design-system/icon/dist/icon.css';
import styles from './sessions.module.css';
import Calendar from './Calendar';

const FallbackIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68" fill="none"><circle cx="33.8415" cy="33.8415" r="33.8415" fill="#003561"></circle><path d="M41.913 21H21.2174C20.5448 21 20 21.5448 20 22.2174V36.8261C20 37.4987 20.5448 38.0435 21.2174 38.0435H24.8696V43.5217C24.8696 43.75 24.9968 43.9588 25.1995 44.0635C25.3991 44.1657 25.6444 44.1517 25.8319 44.0172L34.1948 38.0435H41.913C42.5856 38.0435 43.1304 37.4987 43.1304 36.8261V22.2174C43.1304 21.5448 42.5856 21 41.913 21Z" fill="white"></path><path d="M46.7826 25.8695H44.3478V37.4348C44.3478 38.4434 43.5304 39.2608 42.5217 39.2608H34.585L29.4719 42.913H35.033L42.1839 47.6803C42.3726 47.8057 42.6131 47.8154 42.8084 47.7108C43.0069 47.6048 43.1304 47.3985 43.1304 47.1739V42.913H46.7826C47.4552 42.913 48 42.3682 48 41.6956V27.0869C48 26.4143 47.4552 25.8695 46.7826 25.8695Z" fill="white"></path></svg>`;

type SessionProps = {
  name?: string;
  email?: string;
  title: string;
  summary: string;
  icon?: any;
  duration: string;
  calendar_key: string;
};

function Session({
  name,
  email,
  title,
  summary,
  icon,
  duration,
  calendar_key,
}: SessionProps) {
  const [showCalendar, setShowCalendar] = useState(false);

  function toggleCalendar() {
    setShowCalendar(!showCalendar);
  }

  return (
    <>
      <div
        className={styles.session_wrapper}
        data-testid="group-coaching-topic"
      >
        <div
          className={styles.session}
          onClick={toggleCalendar}
          data-logger-element-id="Group Coaching Topic"
          data-logger-element-label={title}
        >
          <div className={styles.session_details}>
            <div
              className={styles.icon}
              dangerouslySetInnerHTML={{
                __html: icon || FallbackIcon,
              }}
            ></div>
            <div>
              <h3 className={styles.heading}>
                {title}
                <span className={styles.duration}>{duration}</span>
              </h3>
              <p className={styles.summary}>{summary}</p>
            </div>
          </div>
          <Icon
            className={styles.carat}
            icon={showCalendar ? ChevronDownIcon : ChevronRightIcon}
            color="neutral"
          />
        </div>
        {showCalendar && (
          <Calendar calendar_key={calendar_key} name={name} email={email} />
        )}
      </div>
    </>
  );
}

export default Session;
